<template>
  <div class="box13">
    <pageTitle title="常见问题" />

    <commomProblem :problemData="problemData" :styleData="styleData" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "学完C/C++可以从事哪些领域的工作？",
          answer: [
            "C/C++的应用领域非常广泛，例如：服务器开发、人工智能、云计算、信息安全（黑客反黑客）、大数据 、数据平台、嵌入式、流媒体服务器、数据控解、图像处理、音频视频开发、分布式系统、游戏服务器、游戏辅助等，只要知识学的好，就业不是难事。",
          ],
        },
        {
          title: "学完本门课程可以就业么？",
          answer: [
            "本课程具有全面深入课程内容+硬核企业级项目，学完可胜任C/C++软件工程师职位。当然，师傅领进门，修行靠个人，只有持续学习才能获取更好的职业发展机会。",
          ],
        },
        {
          title: "C/C++难么？",
          answer: [
            "说不难是假的，但对于没有任何开发经验的伙伴，学习哪个编程语言都是一样的，只是C/C++多讲了点内容而已；如果随随便便可以学好，那其价值还大么？相信自己，可以学会，并且可以学好！",
          ],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/ai/box17/question.png"),
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box13 {
  padding: 80px 0px 88px;
  width: 100%;
  background-image: linear-gradient(
    -30deg,
    rgba(224, 245, 255, 0.5) 0%,
    rgba(240, 250, 255, 0.5) 18%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(240, 250, 255, 0.5) 82%,
    rgba(224, 245, 255, 0.5) 100%
  );
}
</style>
